// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__39_AS","title":"styles_title__1UmvT","text":"styles_text__118mV"};